module.exports = __webpack_public_path__ + "img/wechat.e49c42e9.svg";